// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Images
import templar from "assets/images/logos/medium-logos/logo-templar.png";
import robur from "assets/images/logos/medium-logos/logo-robur(2).png";
import revbits from "assets/images/logos/medium-logos/logo-revbits.jpeg";
import newhorizons from "assets/images/logos/medium-logos/logo-newhorizons.png";
import instituto from "assets/images/logos/medium-logos/logo-instituto.png";

function Parceiros() {
  return (
    <MKBox py={6}>
      <Container>
        <Grid
          container
          item
          justifyContent="center"
          xs={8}
          sx={{ mx: "auto", textAlign: "center" }}
        >
          <MKTypography variant="h3" mb={1}>
            Nossos parceiros
          </MKTypography>
        </Grid>
        <Grid container justifyContent="center" spacing={3} sx={{ mt: 3 }}>
          <Grid item xs={6} md={4} lg={2}>
            <a href="http://www.templarexecs.com" target="_blank" rel="noopener noreferrer">
              <MKBox component="img" src={templar} alt="Templar" width="60%" opacity={0.9}/>
            </a>
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <a href="http://www.robur.ie" target="_blank" rel="noopener noreferrer">
              <MKBox component="img" src={robur} alt="Robur" width="60%" opacity={0.9} />
            </a>
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <a href="http://www.revbits.com" target="_blank" rel="noopener noreferrer">
            <MKBox component="img" src={revbits} alt="RevBits" width="60%" opacity={0.9} />
            </a>
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={newhorizons} alt="NewHorizons" width="80%" opacity={0.9} />
          </Grid>
          {/* <Grid item xs={6} md={4} lg={2}>
            <a href="http://www.eurobrasil.org.br/" target="_blank" rel="noopener noreferrer">
              <MKBox component="img" src={instituto} alt="NewHorizons" width="80%" opacity={0.9} />
            </a>
          </Grid> */ }
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Parceiros;